import Grid from '@mui/material/Grid';
import makeStyles from '@mui/styles/makeStyles';
import { Formik } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import * as Yup from 'yup';
import CardText from 'react/shared/components/true_link/lab/form/wizard/CardText';
import TrueLinkLink from 'react/shared/components/true_link/main/TrueLinkLink';
import TrueLinkTextInput from 'react/shared/components/true_link/main/form/TrueLinkTextInput';
import PALETTE from 'react/shared/theme/palette';
import schema from 'react/shared/utils/schemas';

const useStyles = makeStyles({
  reviewLabel: {
    color: PALETTE.grey2,
  },
});

export default function EditCardholderName({ cardholderName, onSubmit }) {
  const classes = useStyles();

  const validationSchema = Yup.object().shape({
    cardholderName: schema.asciiString
      .max(23, 'Can not be longer than 23 characters')
      .label('Cardholder name')
      .required(),
  });

  const handleContinue = (values) => {
    onSubmit(values.cardholderName);
  };

  return (
    <Formik
      initialValues={{ cardholderName }}
      onSubmit={handleContinue}
      validationSchema={validationSchema}
    >
      {({ handleChange, handleSubmit, setFieldTouched, values }) => (
        <Grid alignItems="center" className="nameOnCard" container spacing={3}>
          <Grid alignItems="center" container item xs={10}>
            <Grid item sm={4} xs={12}>
              <CardText className={classes.reviewLabel}>Name on card</CardText>
            </Grid>
            <Grid item sm={8} xs={12}>
              <TrueLinkTextInput
                name="cardholderName"
                onChange={handleChange}
                placeholder="Cardholder Name"
                required
                setFieldTouched={setFieldTouched}
                value={values.cardholderName}
              />
            </Grid>
          </Grid>
          <Grid item xs={2}>
            <CardText>
              <TrueLinkLink onClick={handleSubmit}>Save</TrueLinkLink>
            </CardText>
          </Grid>
        </Grid>
      )}
    </Formik>
  );
}

EditCardholderName.propTypes = {
  cardholderName: PropTypes.string.isRequired,
  onSubmit: PropTypes.func,
};
